import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import Close from 'material-ui-icons/Close';
import Typography from 'material-ui/Typography';
import NotificationBar from '../../Parts/NotificationBar.jsx';
import EditTagsDialog from '../../AddressBook/dialogs/EditTagsDialog';

const styles = () => ({
  chatDrawer: {
    width: '100vw',
    flexShrink: 0,
  },
  chatDrawerPaper: {
    width: '100vw',
  },
  // Gemini風レイアウト
  chatLayout: {
    display: 'flex',
    height: '100vh',
    width: '100%',
  },
  chatSidebar: {
    flexShrink: 0,
    borderRight: '1px solid #E0E0E0',
    background: '#F7F8FA',
    display: 'flex',
    flexDirection: 'column',
    transition: 'width 160ms ease',
    overflow: 'hidden',
  },
  chatMain: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  chatTopBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 16px',
    borderBottom: '1px solid #E0E0E0',
  },
  chatTopTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#71737B',
    flex: 1,
  },
  centeredContent: {
    width: '100%',
    maxWidth: '860px',
    margin: '0 auto',
  },
  iconButtonPlain: {
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    padding: '6px',
    borderRadius: '8px',
    color: '#5f6368',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { background: '#ececf1' },
  },
  sidebarNewChat: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    margin: '8px 10px',
    padding: '8px 10px',
    border: '1px solid #1537A6',
    borderRadius: '20px',
    color: '#1537A6',
    fontWeight: 'bold',
    fontSize: '13px',
    cursor: 'pointer',
    background: '#fff',
    whiteSpace: 'nowrap',
  },
  sidebarSectionLabel: {
    fontSize: '11px',
    color: '#9aa0a6',
    padding: '8px 16px 4px',
  },
  conversationList: {
    flex: 1,
    overflowY: 'auto',
    paddingBottom: '8px',
  },
  conversationItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '2px 8px',
    padding: '8px 10px',
    borderRadius: '8px',
    fontSize: '13px',
    color: '#3c4043',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': { background: '#ececf1' },
    '&:hover $conversationDelete': { visibility: 'visible' },
  },
  conversationItemActive: {
    background: '#e7ecfb',
    color: '#1537A6',
    fontWeight: 'bold',
  },
  conversationTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  conversationDelete: {
    visibility: 'hidden',
    marginLeft: '8px',
    color: '#9aa0a6',
    cursor: 'pointer',
    flexShrink: 0,
    fontSize: '13px',
  },
  chatHeader: {
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #E0E0E0',
    position: 'relative',
  },
  chatHeaderTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#71737B',
  },
  chatCloseButton: {
    position: 'absolute',
    right: '4px',
    top: '0px',
  },
  chatMessages: {
    padding: '16px',
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    backgroundColor: '#FFFFFF',
  },
  chatMessage: {
    marginBottom: '12px',
    padding: '12px',
    borderRadius: '8px',
    maxWidth: '100%',
  },
  userMessage: {
    backgroundColor: '#F0F4F9',
    color: '#181819',
    marginLeft: 'auto',
  },

  botMessage: {
    color: '#181819',
    backgroundColor: 'transparent',
    padding: '0',
  },
  itemsTableWrapper: {
    marginTop: 8,
    overflowX: 'auto',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E6E9EC',
    borderRadius: '6px',
    padding: '0',
  },
  itemsTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
    backgroundColor: 'transparent',
    borderSpacing: 0,
  },
  itemsTh: {
    textAlign: 'left',
    padding: '10px 12px',
    borderBottom: '1px solid #E6E9EC',
    color: '#4A4F55',
    backgroundColor: '#F6F8FA',
    fontWeight: 600,
    '&:first-child': {
      borderTopLeftRadius: '6px',
    },
    '&:last-child': {
      borderTopRightRadius: '6px',
    },
  },
  itemsActionBarOutside: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '12px 0',
    backgroundColor: 'transparent',
  },
  itemsTd: {
    padding: '10px 12px',
    borderBottom: '1px solid #F1F3F5',
    color: '#333',
    wordBreak: 'break-all',
    backgroundColor: '#FFFFFF',
  },
  
  chatLoadingMessage: {
    color: '#1537A6',
    marginBottom: '12px',
    marginLeft: '12px',
    fontSize: '24px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    '& span': {
      animation: 'blink 1.4s infinite ease-in-out',
      display: 'inline-block',
      '&:nth-child(1)': {
        animationDelay: '0s',
      },
      '&:nth-child(2)': {
        animationDelay: '0.2s',
      },
      '&:nth-child(3)': {
        animationDelay: '0.4s',
      },
    },
  },
  itemsActionBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '8px',
    gap: '8px',
  },
  actionButton: {
    backgroundColor: '#1537A6',
    color: '#fff',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  actionButtonDisabled: {
    backgroundColor: '#c7cee6',
    color: '#fff',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'not-allowed',
  },

  // Claude風の「文字がきらめく」シマーアニメーション（約1秒周期）
  shimmerText: {
    fontSize: '12px',
    fontWeight: 'bold',
    background: 'linear-gradient(90deg, #b0b3bd 0%, #b0b3bd 40%, #1537A6 50%, #b0b3bd 60%, #b0b3bd 100%)',
    backgroundSize: '200% 100%',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent',
    animation: 'shimmer 1s linear infinite',
  },

  // 「取り込み中…」の末尾ドットを点滅アニメーションさせる（処理中であることを示す）
  ingestingDots: {
    display: 'inline-flex',
    marginLeft: '2px',
    '& span': {
      animation: 'blink 1.4s infinite ease-in-out',
      color: '#b8860b',
      fontWeight: 'bold',
      '&:nth-child(1)': { animationDelay: '0s' },
      '&:nth-child(2)': { animationDelay: '0.2s' },
      '&:nth-child(3)': { animationDelay: '0.4s' },
    },
  },

  '@keyframes shimmer': {
    '0%': {
      backgroundPosition: '100% 0',
    },
    '100%': {
      backgroundPosition: '-100% 0',
    },
  },

  '@keyframes blink': {
    '0%': {
      opacity: 0.2,
      transform: 'translateY(0px) scale(1)',
    },
    '20%': {
      opacity: 1,
      transform: 'translateY(-10px) scale(1.2)',
    },
    '40%': {
      opacity: 0.2,
      transform: 'translateY(0px) scale(1)',
    },
    '100%': {
      opacity: 0.2,
      transform: 'translateY(0px) scale(1)',
    },
  },
  chatInputContainer: {
    padding: '8px 16px 16px',
    background: 'transparent',
  },
  chatInputField: {
    '& .MuiInputBase-root, & .MuiInput-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '28px !important',
      padding: '2px 18px',
      minHeight: 'auto',
      color: '#181819',
      border: '1px solid #D8DBDF',
      boxSizing: 'border-box',
      transition: 'box-shadow 180ms ease, border-color 120ms ease',
      display: 'block',
      overflow: 'hidden',
    },
    '&:focus-within': {
      '& .MuiInputBase-root, & .MuiInput-root': {
        boxShadow: '0 0 0 4px rgba(21,55,166,0.08)',
        borderColor: '#1537A6',
      }
    },
    // Strongly target input/textarea to ensure styles apply across MUI versions
    '& .MuiInputBase-input, & textarea, & input': {
      fontSize: '18px !important',
      color: '#181819 !important',
      padding: '16px 14px !important',
      minHeight: '26px !important',
      lineHeight: '26px !important',
      boxSizing: 'border-box',
      width: '100%',
      resize: 'none',
      outline: 'none',
      background: 'transparent',
    },
    '& .MuiInputBase-input::placeholder, & textarea::placeholder, & input::placeholder': {
      color: '#8B8D8F !important',
      opacity: '1 !important',
      fontSize: '18px !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& fieldset': {
      border: 'none',
    },
  },
});

class ChatDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.setMessagesEndRef = (el) => {
      this.messagesEndEl = el;
    };
    this.setMessagesContainerRef = (el) => {
      this.messagesContainerEl = el;
    };
    this.MAX_INPUT_HEIGHT = 200;
    this.MIN_INPUT_HEIGHT = 20;
    // Web発見候補(取り込み中)のキーマンをポーリングするための管理領域
    this.POLL_INTERVAL_MS = 10000;      // 10秒間隔
    this.POLL_MAX_ATTEMPTS = 30;        // 上限30回（約5分）
    this.pollTimers = {};               // { [corporate_number]: intervalId }
    this.pollAttempts = {};             // { [corporate_number]: count }
    this.pollGaveUp = {};               // { [corporate_number]: true } 上限到達で打ち切った企業（再開しない）
    this.pollGeneration = 0;            // 会話切替ごとに増やす世代トークン（in-flightの旧応答を無効化する）
    this.isUnmounted = false;           // アンマウント後の setState を防ぐ
    this.state = {
      // selectedByMessage: { [messageId]: Set(ids) }
      selectedByMessage: {},
      taggingInProgress: {},
      editDialogOpen: false,
      editDialogSelectedIds: [],
      editDialogMessageId: null,
      showNotification: false,
      notificationMessage: '',
      notificationType: 'success',
      // 外部探索（Web発見）を明示的にONにするトグル
      includeWebDiscovery: false,
      // 会話履歴サイドバーの開閉（Gemini風。デフォルト開く）
      showSidebar: true,
      // 取り込み完了したWeb発見候補のキーマン { [corporate_number]: { ready, keymen } }
      webCandidateKeymen: {},
    };
  }

  openEditTagsDialogForMessage = (messageId) => {
    const ids = (this.state.selectedByMessage[messageId] || []).slice();
    if (!ids || ids.length === 0) return;
    this.setState({ editDialogOpen: true, editDialogSelectedIds: ids, editDialogMessageId: messageId });
  }

  closeEditTagsDialog = () => {
    this.setState({ editDialogOpen: false, editDialogSelectedIds: [], editDialogMessageId: null });
  }

  saveTagsAiRecommend = async (tagsArray) => {
    // Use existing updateTag action and include relocation_personnel_ids
    const messageId = this.state.editDialogMessageId;
    const ids = (messageId && (this.state.selectedByMessage[messageId] || [])) || [];
    if (!ids.length || !tagsArray || tagsArray.length === 0) return;
    const query = {
      relocation_personnel_ids: ids,
      tags: tagsArray,
      type: 0,
    };
    try {
      if (typeof this.props.postExecutiveListUpdateTag === 'function') {
        // call the existing update action with relocation_personnel_ids
        this.props.postExecutiveListUpdateTag(query);
        this.setState({ showNotification: true, notificationMessage: 'リストに保存しました', notificationType: 'success' });
      } else {
        // fallback: POST directly to existing endpoint
        await fetch('/executive_list/tags', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(query),
        });
        this.setState({ showNotification: true, notificationMessage: 'リストに保存しました', notificationType: 'success' });
      }
    } catch (e) {
      this.setState({ showNotification: true, notificationMessage: '保存に失敗しました', notificationType: 'error' });
    } finally {
      this.closeEditTagsDialog();
      // clear selection for that message
      if (messageId) {
        this.setState((s) => ({ selectedByMessage: { ...s.selectedByMessage, [messageId]: [] } }));
      }
    }
  }

  renderNotification() {
    return (
      <div style={{ position: 'fixed', zIndex: 10000, top: 10, left: 'calc(50% - 150px)' }}>
        <NotificationBar
          message={this.state.notificationMessage}
          type={this.state.notificationType}
          open={this.state.showNotification}
          onHandleClose={() => { this.setState({ showNotification: false }); }}
          autoClose={true}
          animation="fade"
        />
      </div>
    );
  }

  toggleRowSelection = (messageId, rowId) => {
    this.setState((prev) => {
      const map = { ...prev.selectedByMessage };
      const set = new Set(map[messageId] || []);
      if (set.has(rowId)) set.delete(rowId); else set.add(rowId);
      map[messageId] = Array.from(set);
      return { selectedByMessage: map };
    });
  }

  setSelectAll = (messageId, ids) => {
    this.setState((prev) => {
      const map = { ...prev.selectedByMessage };
      map[messageId] = ids.slice();
      return { selectedByMessage: map };
    });
  }

  postTagsForMessage = async (messageId) => {
    const ids = this.state.selectedByMessage[messageId] || [];
    if (!ids || ids.length === 0) return;
    this.setState((s) => ({ taggingInProgress: { ...s.taggingInProgress, [messageId]: true } }));
    try {
      await fetch('/executive_list/tags', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids }),
        credentials: 'same-origin',
      });
      // on success clear selection for that message
      this.setState((s) => ({ selectedByMessage: { ...s.selectedByMessage, [messageId]: [] } }));
      // simple feedback
      try { window.alert('タグを登録しました'); } catch (e) { /* ignore */ }
    } catch (e) {
      try { window.alert('タグ登録に失敗しました'); } catch (e2) { /* ignore */ }
    } finally {
      this.setState((s) => ({ taggingInProgress: { ...s.taggingInProgress, [messageId]: false } }));
    }
  }

  adjustInputHeight = (el) => {
    if (!el) return;
    try {
      el.style.height = 'auto';
      const raw = el.scrollHeight || 0;
      const h = Math.max(Math.min(raw, this.MAX_INPUT_HEIGHT), this.MIN_INPUT_HEIGHT);
      el.style.height = `${h}px`;
    } catch (e) {
      // ignore
    }
  }

  componentDidMount() {
    // 復元されたメッセージ等に取り込み中のWeb発見候補があればポーリングを開始する
    this.startPollingForIngestingCandidates();
  }

  componentWillUnmount() {
    // アンマウント後の setState（in-flight応答）を防ぐ
    this.isUnmounted = true;
    // 全ポーリングタイマーを停止する
    Object.keys(this.pollTimers).forEach((corpNum) => {
      if (this.pollTimers[corpNum]) {
        clearInterval(this.pollTimers[corpNum]);
      }
    });
    this.pollTimers = {};
  }

  // メッセージ内の web_candidates を走査し、status:"ingesting" の企業について
  // corporate_number をキーにキーマン取得のポーリングを開始する（既に完了・実行中のものは除く）
  startPollingForIngestingCandidates = () => {
    const messages = this.props.messages || [];
    messages.forEach((message) => {
      const candidates = Array.isArray(message.webCandidates) ? message.webCandidates : [];
      candidates.forEach((cand) => {
        if (!cand) return;
        const corpNum = typeof cand.corporate_number === 'string' || typeof cand.corporate_number === 'number'
          ? String(cand.corporate_number) : '';
        if (corpNum === '') return;
        // レスポンスに既にkeymenが含まれていれば取得不要
        const hasInlineKeymen = Array.isArray(cand.keymen) && cand.keymen.length > 0;
        if (hasInlineKeymen) return;
        // 既に取得完了 or ポーリング実行中 or 上限到達で打ち切り済みなら何もしない
        const existing = this.state.webCandidateKeymen[corpNum];
        if (existing && existing.ready) return;
        if (this.pollTimers[corpNum]) return;
        if (this.pollGaveUp[corpNum]) return;

        if (cand.status === 'ingesting') {
          // 取り込み中: 一定間隔でポーリング
          this.startPollingCandidate(corpNum);
        } else if (this.pollAttempts[corpNum] === undefined) {
          // 収録済み等だが keymen が空: corporate_number で単発取得を試みる
          this.pollAttempts[corpNum] = 0;
          this.pollCandidateOnce(corpNum);
        }
      });
    });
  }

  // 単一企業のポーリングを開始する
  startPollingCandidate = (corpNum) => {
    if (typeof this.props.getWebCandidateKeymen !== 'function') return;
    this.pollAttempts[corpNum] = 0;
    // 初回は即時実行し、以降は一定間隔で実行する
    this.pollCandidateOnce(corpNum);
    this.pollTimers[corpNum] = setInterval(() => {
      this.pollCandidateOnce(corpNum);
    }, this.POLL_INTERVAL_MS);
  }

  // 単一企業のキーマン取得を1回試行する。ready:true で完了、上限到達で打ち切る。
  pollCandidateOnce = (corpNum) => {
    this.pollAttempts[corpNum] = (this.pollAttempts[corpNum] || 0) + 1;
    // 発行時の世代を捕捉。会話切替後に解決した旧応答は無視する（別会話へのデータ混入防止）。
    const generation = this.pollGeneration;
    const isSingleShot = !this.pollTimers[corpNum]; // タイマー無し = 収録済みの単発取得

    this.props.getWebCandidateKeymen(corpNum)
      .then((response) => {
        if (this.isUnmounted || generation !== this.pollGeneration) return;
        const data = response && response.data ? response.data : {};
        const isReady = data.ready === true;
        const keymen = Array.isArray(data.keymen) ? data.keymen : [];
        if (isReady) {
          this.stopPollingCandidate(corpNum);
          this.setState((prev) => ({
            webCandidateKeymen: { ...prev.webCandidateKeymen, [corpNum]: { ready: true, keymen } },
          }));
        } else if (this.pollAttempts[corpNum] >= this.POLL_MAX_ATTEMPTS) {
          // 上限到達で打ち切り（取り込みが完了しなかった）。以降は再開しない。
          this.pollGaveUp[corpNum] = true;
          this.stopPollingCandidate(corpNum);
        }
      })
      .catch(() => {
        if (this.isUnmounted || generation !== this.pollGeneration) return;
        if (isSingleShot) {
          // 単発取得の一時失敗は、次のメッセージ更新で再取得できるようフラグをリセットする
          delete this.pollAttempts[corpNum];
        } else if (this.pollAttempts[corpNum] >= this.POLL_MAX_ATTEMPTS) {
          // ポーリングは上限到達なら打ち切る（一時的な失敗は次回リトライ）
          this.pollGaveUp[corpNum] = true;
          this.stopPollingCandidate(corpNum);
        }
      });
  }

  stopPollingCandidate = (corpNum) => {
    if (this.pollTimers[corpNum]) {
      clearInterval(this.pollTimers[corpNum]);
      delete this.pollTimers[corpNum];
    }
  }

  componentDidUpdate(prevProps) {
    const conversationSwitched = prevProps.currentConversationId !== this.props.currentConversationId;
    if (conversationSwitched) {
      // 会話が切り替わったら、旧会話のポーリングを全停止して取得状態をリセットする
      Object.keys(this.pollTimers).forEach((corpNum) => {
        if (this.pollTimers[corpNum]) clearInterval(this.pollTimers[corpNum]);
      });
      this.pollTimers = {};
      this.pollAttempts = {};
      this.pollGaveUp = {};
      this.pollGeneration += 1; // in-flightの旧応答を無効化する
      // webCandidateKeymen のクリアは非同期のため、クリア完了後に新会話のポーリングを開始する
      this.setState({ webCandidateKeymen: {} }, () => {
        this.startPollingForIngestingCandidates();
      });
    } else if (this.props.messages !== prevProps.messages) {
      // メッセージが更新されたら、取り込み中候補のポーリングを開始する
      this.startPollingForIngestingCandidates();
    }

    const messagesChanged = (this.props.messages && prevProps.messages) ? (this.props.messages.length !== prevProps.messages.length) : false;
    const loadingChanged = this.props.isLoading !== prevProps.isLoading;
    if (messagesChanged || loadingChanged) {
      // Prefer scrolling the messages container to its full scrollHeight
      if (this.messagesContainerEl) {
        try {
          const top = this.messagesContainerEl.scrollHeight - this.messagesContainerEl.clientHeight;
          this.messagesContainerEl.scrollTo({ top: top >= 0 ? top : 0, behavior: 'smooth' });
          // ensure fully at bottom after layout (fallback for subtle off-by-one)
          const SMALL_SCROLL_DELAY = 50;
          setTimeout(() => {
            try { this.messagesContainerEl.scrollTop = this.messagesContainerEl.scrollHeight; } catch (e) { void e; }
          }, SMALL_SCROLL_DELAY);
        } catch (e) {
          // fallback: use direct assignment
          this.messagesContainerEl.scrollTop = this.messagesContainerEl.scrollHeight;
        }
        return;
      }
      if (this.messagesEndEl) {
        try {
          this.messagesEndEl.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } catch (e) {
          this.messagesEndEl.scrollIntoView();
        }
      }
    }
  }

  toggleSidebar = () => {
    this.setState(prev => ({ showSidebar: !prev.showSidebar }));
  };

  // 会話履歴サイドバーを描画する（Gemini風。開閉可能）
  renderSidebar = () => {
    const { classes, conversations, currentConversationId, onNewChat, onSelectConversation, onDeleteConversation } = this.props;
    const SIDEBAR_WIDTH_OPEN = 280;
    const SIDEBAR_WIDTH_CLOSED = 56;
    const showSidebar = this.state.showSidebar;
    const conversationList = Array.isArray(conversations) ? conversations : [];
    const sortedConversations = conversationList.slice().sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));

    return (
      <div className={classes.chatSidebar} style={{ width: showSidebar ? SIDEBAR_WIDTH_OPEN : SIDEBAR_WIDTH_CLOSED }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: showSidebar ? 'space-between' : 'center', padding: '12px 12px 8px', gap: '8px' }}>
          {showSidebar && (
            <span style={{ fontSize: '15px', fontWeight: 600, color: '#71737B', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              Keyman Database AI
            </span>
          )}
          <button
            type="button"
            className={classes.iconButtonPlain}
            onClick={this.toggleSidebar}
            title={showSidebar ? 'サイドバーを閉じる' : 'サイドバーを開く'}
          >
            <span role="img" aria-label="メニュー" style={{ fontSize: '18px' }}>☰</span>
          </button>
        </div>
        <button
          type="button"
          className={classes.sidebarNewChat}
          onClick={() => { if (typeof onNewChat === 'function') onNewChat(); }}
          title="新しいチャット"
        >
          ＋{showSidebar ? ' 新しいチャット' : ''}
        </button>
        {showSidebar && (
          <React.Fragment>
            <div className={classes.sidebarSectionLabel}>最近のチャット</div>
            <div className={classes.conversationList}>
              {sortedConversations.map((c) => {
                const isActive = c.id === currentConversationId;
                return (
                  <div
                    key={c.id}
                    className={`${classes.conversationItem} ${isActive ? classes.conversationItemActive : ''}`}
                    onClick={() => { if (typeof onSelectConversation === 'function') onSelectConversation(c.id); }}
                    title={c.title || '新しいチャット'}
                  >
                    <span className={classes.conversationTitle}>{c.title || '新しいチャット'}</span>
                    <span
                      className={classes.conversationDelete}
                      role="img"
                      aria-label="削除"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (typeof onDeleteConversation !== 'function') return;
                        if (window.confirm('このチャットを削除しますか？')) {
                          onDeleteConversation(c.id);
                        }
                      }}
                    >🗑</span>
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  };

  // キーマン一覧をチェックボックス付きテーブルで描画する（web_candidates / role_gap_candidates 共通）。
  // sectionKey はセクションごとに独立した選択状態を持たせるためのキー。
  renderKeymenTable = (sectionKey, keymen) => {
    const { classes } = this.props;
    if (!Array.isArray(keymen) || keymen.length === 0) return null;
    const hasRelocation = keymen.some(km => km && km.relocation_at);
    const kmCols = hasRelocation ? ['name', 'honorific', 'relocation_at'] : ['name', 'honorific'];
    const headerLabel = (col) => {
      if (col === 'name') return '氏名';
      if (col === 'honorific') return '役職';
      if (col === 'relocation_at') return '異動日';
      return col;
    };
    const formatCell = (col, value) => {
      if (value === null || typeof value === 'undefined') return '';
      if (col === 'relocation_at') {
        try {
          const d = new Date(value);
          if (!Number.isNaN(d.getTime())) return d.toISOString().split('T')[0];
        } catch (e) { /* fallthrough */ }
        return String(value);
      }
      return String(value);
    };
    const selected = this.state.selectedByMessage[sectionKey] || [];
    // 選択可能な全キーマンのid（全件チェック用）
    const allIds = keymen
      .map(km => (km && km.id !== undefined && km.id !== null ? String(km.id) : ''))
      .filter(id => id !== '');
    const isAllSelected = allIds.length > 0 && allIds.every(id => selected.indexOf(id) !== -1);
    return (
      <div className={classes.itemsTableWrapper} style={{ marginTop: 4 }}>
        <table className={classes.itemsTable}>
          <thead>
            <tr>
              <th className={classes.itemsTh} style={{ width: 40 }}>
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={(e) => {
                    if (e.target.checked) this.setSelectAll(sectionKey, allIds);
                    else this.setSelectAll(sectionKey, []);
                  }}
                />
              </th>
              {kmCols.map(col => (
                <th key={`${sectionKey}-h-${col}`} className={classes.itemsTh}>{headerLabel(col)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {keymen.map((km, ki) => {
              const kmId = km && km.id !== undefined && km.id !== null ? String(km.id) : '';
              const kmChecked = kmId !== '' && selected.indexOf(kmId) !== -1;
              return (
                <tr key={`${sectionKey}-km-${ki}`}>
                  <td className={classes.itemsTd} style={{ width: 40 }}>
                    <input
                      type="checkbox"
                      checked={!!kmChecked}
                      disabled={kmId === ''}
                      onChange={() => { if (kmId !== '') this.toggleRowSelection(sectionKey, kmId); }}
                    />
                  </td>
                  {kmCols.map(col => {
                    // 役職セルに出典(source_url)リンクを付ける（enriched_items の出典と同じ見せ方）。null は出さない。
                    const kmSourceUrl = km && typeof km.source_url === 'string' && km.source_url !== '' ? km.source_url : '';
                    return (
                      <td key={`${sectionKey}-km-${ki}-${col}`} className={classes.itemsTd}>
                        {formatCell(col, km ? km[col] : '')}
                        {col === 'honorific' && kmSourceUrl !== '' && (
                          <a
                            href={kmSourceUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: 4, fontSize: '11px', whiteSpace: 'nowrap' }}
                            title="役職の出典（Web補完）"
                          ><span role="img" aria-label="出典リンク">🔗</span>出典</a>
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  // AI検索条件のプレビュー（最大30件）と「全てを見る」ボタンを描画する。
  // preview.items は通常の検索結果と同一形式(RelocationPersonnelResource)。
  renderConditionsPreview = (message) => {
    const { classes, onSeeAllConditions } = this.props;
    const items = Array.isArray(message.previewItems) ? message.previewItems : [];
    const total = typeof message.previewTotal === 'number' ? message.previewTotal : items.length;

    // 0件: 「該当する結果がありません」。「全てを見る」は出さない。
    if (total === 0 || items.length === 0) {
      return (
        <div style={{ marginTop: 8, fontSize: '13px', color: '#71737b' }}>
          該当する結果がありません。
        </div>
      );
    }

    const cols = ['company', 'name', 'honorific', 'relocation_at'];
    const headerLabel = (col) => {
      if (col === 'company') return '企業';
      if (col === 'name') return '氏名';
      if (col === 'honorific') return '役職';
      if (col === 'relocation_at') return '異動日';
      return col;
    };
    // 検索結果(RelocationPersonnelResource)の形式に合わせてセル値を解決する。
    //  - 企業名: company または company_name
    //  - 異動日: relocation_at はオブジェクト { date: ... } のことがある
    const cellValue = (row, col) => {
      if (!row) return '';
      if (col === 'company') {
        return row.company || row.company_name || '';
      }
      if (col === 'relocation_at') {
        const raw = row.relocation_at;
        if (raw && typeof raw === 'object') return raw.date || '';
        return raw || '';
      }
      return row[col];
    };
    const formatCell = (col, value) => {
      if (value === null || typeof value === 'undefined' || value === '') return '';
      if (col === 'relocation_at') {
        try {
          const d = new Date(value);
          if (!Number.isNaN(d.getTime())) return d.toISOString().split('T')[0];
        } catch (e) { /* fallthrough */ }
        return String(value);
      }
      return String(value);
    };

    return (
      <div style={{ marginTop: 8 }}>
        <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4 }}>
          プレビュー（該当 {total.toLocaleString()} 件中 最大{items.length}件）
        </div>
        <div className={classes.itemsTableWrapper}>
          <table className={classes.itemsTable}>
            <thead>
              <tr>
                {cols.map(col => (
                  <th key={`pv-h-${message.id}-${col}`} className={classes.itemsTh}>{headerLabel(col)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((row, idx) => (
                <tr key={`pv-${message.id}-${idx}`}>
                  {cols.map(col => (
                    <td key={`pv-${message.id}-${idx}-${col}`} className={classes.itemsTd}>
                      {formatCell(col, cellValue(row, col))}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={classes.itemsActionBarOutside}>
          <button
            className={classes.actionButton}
            onClick={() => {
              if (typeof onSeeAllConditions === 'function') {
                onSeeAllConditions(message.previewConditions, message.previewUnmapped);
              }
            }}
          >
            全てを見る（全 {total.toLocaleString()} 件）
          </button>
        </div>
      </div>
    );
  };

  // 稼働照会(intent=status)の構造化データ（status_result: query / period / count / items[企業一覧]）を描画する。
  // 回答文は message.text で表示済みのため、ここでは件数と企業リストのみ補足表示する。
  renderStatusResult = (message) => {
    const { classes } = this.props;
    const result = message.statusResult || {};
    const items = Array.isArray(result.items) ? result.items : [];
    const count = typeof result.count === 'number' ? result.count : null;
    // period は文字列 or { from, to } を想定して表示用に整形する
    const rawPeriod = result.period;
    let period = '';
    if (typeof rawPeriod === 'string') {
      period = rawPeriod;
    } else if (rawPeriod && typeof rawPeriod === 'object') {
      const from = rawPeriod.from || rawPeriod.start || '';
      const to = rawPeriod.to || rawPeriod.end || '';
      period = from !== '' || to !== '' ? `${from} 〜 ${to}` : '';
    }
    // 企業一覧の要素は文字列 or オブジェクト（企業名キーの揺れを吸収する）
    const companyName = (item) => {
      if (item === null || typeof item === 'undefined') return '';
      if (typeof item !== 'object') return String(item);
      return item.company || item.company_name || item.corporation_name || item.name || '';
    };
    // セルの表示（空値は「-」に正規化する）
    const cell = (value) => {
      if (value === null || typeof value === 'undefined' || value === '') return '-';
      return String(value);
    };
    // 日時文字列を「YYYY-MM-DD HH:mm」に整形する（日付のみ・解釈不能な値はそのまま返す）
    const formatDateTime = (value) => {
      if (typeof value !== 'string' || value === '') return value || '';
      const m = value.match(/^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2}))?/);
      if (!m) return value;
      const [, date, time] = m;
      return time ? `${date} ${time}` : date;
    };
    // 日程未確定の一覧用の会社名（name は氏名の可能性があるため参照しない）
    const pendingCompanyName = (item) => {
      if (!item || typeof item !== 'object') return '';
      return item.company || item.company_name || item.corporation_name || '';
    };
    // 商談獲得日時（日時優先、無ければ日付）
    const acquiredAt = (item) => {
      if (!item || typeof item !== 'object') return '';
      return formatDateTime(item.acquired_at_datetime || item.acquired_at || '');
    };
    // コール（回数と最終コール日時を1セルにまとめる）
    // call_count は文字列で返る場合もあるため数値に変換して判定する
    const callText = (item) => {
      if (!item || typeof item !== 'object') return '-';
      const parsed = Number(item.call_count);
      const c = Number.isFinite(parsed) ? parsed : 0;
      if (c <= 0) return 'なし';
      return item.last_call_at ? `${c}件（最終 ${formatDateTime(item.last_call_at)}）` : `${c}件`;
    };
    // 日程未確定の商談一覧は、会社名・役職・氏名・商談獲得日時・コールを列として表示する。
    // それ以外の稼働照会（コール件数等）は明細を持たないため、従来どおり企業名のみの表にフォールバックする。
    const isPendingList = result.query === 'pending_appointment_schedule'
      || items.some((item) => item && typeof item === 'object'
        && ('person' in item || 'acquired_at_datetime' in item || 'acquired_at' in item));

    if (count === null && period === '' && items.length === 0) return null;

    return (
      <div style={{ marginTop: 8 }}>
        {(count !== null || period !== '') && (
          <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4 }}>
            {period !== '' ? `期間: ${period}` : ''}
            {period !== '' && count !== null ? ' / ' : ''}
            {count !== null ? `${count.toLocaleString()} 件` : ''}
          </div>
        )}
        {items.length > 0 && isPendingList && (
          <div className={classes.itemsTableWrapper}>
            <table className={classes.itemsTable}>
              <thead>
                <tr>
                  <th className={classes.itemsTh}>会社名</th>
                  <th className={classes.itemsTh}>役職</th>
                  <th className={classes.itemsTh}>氏名</th>
                  <th className={classes.itemsTh}>商談獲得日時</th>
                  <th className={classes.itemsTh}>コール</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={`st-${message.id}-${idx}`}>
                    <td className={classes.itemsTd}>{cell(pendingCompanyName(item))}</td>
                    <td className={classes.itemsTd}>{cell(item && item.honorific)}</td>
                    <td className={classes.itemsTd}>{cell(item && item.person)}</td>
                    <td className={classes.itemsTd}>{cell(acquiredAt(item))}</td>
                    <td className={classes.itemsTd}>{callText(item)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {items.length > 0 && !isPendingList && (
          <div className={classes.itemsTableWrapper}>
            <table className={classes.itemsTable}>
              <thead>
                <tr>
                  <th className={classes.itemsTh}>企業</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={`st-${message.id}-${idx}`}>
                    <td className={classes.itemsTd}>{companyName(item)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // Web補完セクションの進捗（探索中… / 取得できませんでした）をセクション単位で表示する。
  // enriched_items は items に反映されるため、pending 時のみ補強中の注記を出す。
  renderWebSectionStatus = (message) => {
    const sections = message && message.webSections;
    const webCompletionPending = message && message.webCompletionPending;
    if (!sections || typeof sections !== 'object') {
      // sections が無い場合（旧挙動）は従来の汎用インジケータを出す
      if (webCompletionPending) {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: 8 }}>
            <span className={this.props.classes.shimmerText}>Web検索で候補を探しています（数十秒かかることがあります）</span>
          </div>
        );
      }
      return null;
    }

    const { classes } = this.props;
    // enriched_items は items に反映されるため空状態メッセージは出さない（label/empty空）。
    const items = [
      {
        key: 'enriched_items',
        label: '役職情報',
        pending: '役職情報を補強しています',
        empty: '',
        getArr: () => null,
      },
      {
        key: 'web_candidates',
        label: 'Web検索の候補企業',
        pending: 'Web検索で候補企業を探しています',
        empty: '該当する企業はありませんでした',
        getArr: () => message.webCandidates,
      },
      {
        key: 'role_gap_candidates',
        label: 'KDBに存在しない企業・役職の補完',
        pending: 'KDBに存在しない企業・役職を補完しています',
        empty: '該当する企業はありませんでした',
        getArr: () => message.roleGapCandidates,
      },
    ];

    return (
      <div style={{ marginTop: 8 }}>
        {items.map(({ key, label, pending, empty, getArr }) => {
          const status = sections[key];
          // 探索中: ローダー＋シマー
          if (status === 'pending') {
            return (
              <div key={`sec-${key}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: 4 }}>
                <div className={classes.chatLoadingMessage} style={{ marginLeft: 0, marginBottom: 0, lineHeight: 1, transform: 'translateY(-6px)' }}>
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </div>
                <span className={classes.shimmerText}>{pending}</span>
              </div>
            );
          }
          // ジョブ失敗のときだけオレンジのエラー表示
          if (status === 'failed') {
            return (
              <div key={`sec-${key}`} style={{ marginTop: 2, fontSize: '12px', color: '#b8860b' }}>
                {label}の取得に失敗しました
              </div>
            );
          }
          // タイムアウトは中立表示（オレンジにしない）
          if (status === 'timeout') {
            return (
              <div key={`sec-${key}`} style={{ marginTop: 2, fontSize: '12px', color: '#71737b' }}>
                {label}を時間内に取得できませんでした（時間をおいて再度お試しください）
              </div>
            );
          }
          // 完了かつ0件は空状態メッセージ（エラーではない）
          if (status === 'ready' && empty !== '') {
            const arr = getArr();
            if (!Array.isArray(arr) || arr.length === 0) {
              return (
                <div key={`sec-${key}`} style={{ marginTop: 2, fontSize: '12px', color: '#71737b' }}>
                  {label}: {empty}
                </div>
              );
            }
          }
          return null;
        })}
      </div>
    );
  };

  // セクション単位の「リストに保存」ボタン
  renderSaveButton = (sectionKey) => {
    const { classes } = this.props;
    const selectedCount = (this.state.selectedByMessage[sectionKey] || []).length;
    return (
      <div className={classes.itemsActionBarOutside}>
        <button
          className={this.state.taggingInProgress[sectionKey] ? classes.actionButtonDisabled : classes.actionButton}
          disabled={this.state.taggingInProgress[sectionKey] || !selectedCount}
          onClick={() => this.openEditTagsDialogForMessage(sectionKey)}
        >
          リストに保存
        </button>
      </div>
    );
  }

  render() {
    const {
      classes,
      open,
      onClose,
      messages,
      onSubmit,
      isLoading,
    } = this.props;

    return (
      <Drawer
        anchor="left"
        open={open}
        onClose={onClose}
        classes={{
          paper: classes.chatDrawerPaper,
        }}
        className={classes.chatDrawer}
      >
        <div className={classes.chatLayout}>
        {this.renderSidebar()}
        <div className={classes.chatMain}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 12px' }}>
          <IconButton onClick={onClose}>
            <Close color="inherit" width={20} height={20} />
          </IconButton>
        </div>
        <div className={classes.chatMessages} ref={this.setMessagesContainerRef}>
        <div className={classes.centeredContent}>
          {messages.map((message) => {
            const MAX_DYNAMIC_COLUMNS = 5;
            const hasItems = message.sender !== 'user' && Array.isArray(message.items) && message.items.length > 0;
            let columns = [];
            let isRecommendPreview = false;
            if (hasItems) {
              const first = message.items[0] || {};
              isRecommendPreview = ['company', 'honorific', 'relocation_at'].some(k => Object.prototype.hasOwnProperty.call(first, k));
              if (isRecommendPreview) {
                columns = ['id', 'company', 'name', 'honorific', 'relocation_at'];
              } else {
                const preferred = ['id', 'name', 'corporate_number'];
                columns = preferred.filter(k => Object.prototype.hasOwnProperty.call(first, k));
                if (columns.length === 0) {
                  columns = Object.keys(first).slice(0, MAX_DYNAMIC_COLUMNS);
                }
              }
            }
            const headerLabel = (key) => {
              if (key === 'id') return 'ID';
              if (key === 'company') return '企業';
              if (key === 'name') return '氏名';
              if (key === 'honorific') return '役職';
              if (key === 'relocation_at') return '異動日';
              if (key === 'corporate_number') return '法人番号';
              return key;
            };
            return (
              <div
                key={message.id}
                className={`${classes.chatMessage} ${message.sender === 'user' ? classes.userMessage : classes.botMessage}`}
              >
                <Typography style={{ fontSize: '15px', lineHeight: 1.7, whiteSpace: 'pre-wrap' }}>{message.text}</Typography>
                {message.isConditionsPreview && this.renderConditionsPreview(message)}
                {message.isStatusResult && this.renderStatusResult(message)}
                {hasItems && (() => {
                  const first = message.items[0] || {};
                  const isRecommend = ['company', 'honorific', 'relocation_at'].some(k => Object.prototype.hasOwnProperty.call(first, k));
                  const getRowId = (r) => {
                    if (r == null) return null;
                    if (r.id !== undefined) return String(r.id);
                    if (r.ID !== undefined) return String(r.ID);
                    if (r.Id !== undefined) return String(r.Id);
                    return null;
                  };
                  const allIds = message.items.map(getRowId).filter(Boolean);
                  const selected = (this.state.selectedByMessage && this.state.selectedByMessage[message.id]) || [];
                  const isAllSelected = allIds.length > 0 && selected.length === allIds.length;
                  const formatCell = (col, value) => {
                    if (value === null || typeof value === 'undefined') return '';
                    if (col === 'relocation_at') {
                      try {
                        const d = new Date(value);
                        if (!Number.isNaN(d.getTime())) return d.toISOString().split('T')[0];
                      } catch (e) { /* fallthrough */ }
                      return String(value);
                    }
                    if (typeof value === 'object') return JSON.stringify(value);
                    return String(value);
                  };
                  return (
                    <React.Fragment>
                    {isRecommend && (
                      <div style={{ fontSize: '12px', fontWeight: 'bold', marginTop: 8, marginBottom: 4 }}>
                        Keyman Databaseからのレコメンド
                      </div>
                    )}
                    <div className={classes.itemsTableWrapper}>
                      <table className={classes.itemsTable}>
                        <thead>
                          <tr>
                            {isRecommend && (
                              <th className={classes.itemsTh} style={{width: 40}}>
                                <input
                                  type="checkbox"
                                  checked={isAllSelected}
                                  onChange={(e) => {
                                    if (e.target.checked) this.setSelectAll(message.id, allIds);
                                    else this.setSelectAll(message.id, []);
                                  }}
                                />
                              </th>
                            )}
                            {columns.map(col => (
                              <th key={`h-${col}`} className={classes.itemsTh}>{headerLabel(col)}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {message.items.map((row, idx) => {
                            const rowId = getRowId(row);
                            const checked = (this.state.selectedByMessage[message.id] || []).indexOf(rowId) !== -1;
                            const totalCols = columns.length + (isRecommend ? 1 : 0);
                            // 個別理由（items[].reason）。空なら非表示。
                            const rowReason = typeof row.reason === 'string' ? row.reason.trim() : '';
                            // 役職がWeb補強済みで出典URLがある場合は出典リンクを付ける。
                            const showHonorificSource = row.honorific_enriched === true
                              && typeof row.honorific_source_url === 'string' && row.honorific_source_url !== '';
                            return (
                              <React.Fragment key={`r-${message.id}-${idx}`}>
                              <tr>
                                {isRecommend && (
                                  <td className={classes.itemsTd} style={{width: 40}}>
                                    <input
                                      type="checkbox"
                                      checked={!!checked}
                                      onChange={() => { if (rowId) this.toggleRowSelection(message.id, rowId); }}
                                    />
                                  </td>
                                )}
                                {columns.map(col => (
                                  <td key={`c-${message.id}-${idx}-${col}`} className={classes.itemsTd}>
                                    {formatCell(col, row[col])}
                                    {col === 'honorific' && showHonorificSource && (
                                      <a
                                        href={row.honorific_source_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ marginLeft: 4, fontSize: '11px', whiteSpace: 'nowrap' }}
                                        title="役職の出典（Web補強）"
                                      ><span role="img" aria-label="出典リンク">🔗</span>出典</a>
                                    )}
                                  </td>
                                ))}
                              </tr>
                              {rowReason !== '' && (
                                <tr>
                                  <td
                                    className={classes.itemsTd}
                                    colSpan={totalCols}
                                    style={{ color: '#71737b', fontSize: '11px', whiteSpace: 'pre-line' }}
                                  >
                                    理由: {rowReason}
                                  </td>
                                </tr>
                              )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    {isRecommend && (
                      <div className={classes.itemsActionBarOutside}>
                                <button
                                  className={this.state.taggingInProgress[message.id] ? classes.actionButtonDisabled : classes.actionButton}
                                  disabled={this.state.taggingInProgress[message.id] || !((this.state.selectedByMessage[message.id] || []).length)}
                                  onClick={() => this.openEditTagsDialogForMessage(message.id)}
                                >
                                  リストに保存
                                </button>
                      </div>
                    )}
                    </React.Fragment>
                  );
                })()}
                {Array.isArray(message.webCandidates) && message.webCandidates.length > 0 && (() => {
                  // Web発見候補のキーマンを取得する。
                  //  - status:"existing" → cand.keymen をそのまま使用（即表示・選択可）
                  //  - status:"ingesting" → ポーリング結果(webCandidateKeymen)から取得（ready後に表示・選択可）
                  const getCandidateKeymen = (cand) => {
                    // レスポンスに含まれる keymen を優先
                    if (cand && Array.isArray(cand.keymen) && cand.keymen.length > 0) {
                      return cand.keymen;
                    }
                    // 空の場合は corporate_number で取得した結果（ポーリング/単発取得）を使う
                    const corpNum = cand && cand.corporate_number != null ? String(cand.corporate_number) : '';
                    const polled = corpNum !== '' ? this.state.webCandidateKeymen[corpNum] : null;
                    return polled && polled.ready && Array.isArray(polled.keymen) ? polled.keymen : [];
                  };
                  // このメッセージのWeb候補に選択可能なキーマンが存在するか（保存ボタンの表示可否）
                  const hasSelectableKeymen = message.webCandidates.some(c => getCandidateKeymen(c).length > 0);
                  return (
                  <div style={{ marginTop: 8 }}>
                    <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4, display: 'flex', alignItems: 'center' }}>
                      Web検索で新たに見つけた企業（{message.webCandidates.length}社）
                      <span
                        style={{
                          marginLeft: 6,
                          fontSize: '10px',
                          fontWeight: 'bold',
                          color: '#fff',
                          background: '#e8552d',
                          borderRadius: 3,
                          padding: '1px 5px',
                          letterSpacing: 0.5,
                        }}
                      >NEW</span>
                    </div>
                    {message.webCandidates.map((cand, i) => {
                      const candCompany = cand && typeof cand.company === 'string' ? cand.company : '';
                      const candReason = cand && typeof cand.reason === 'string' ? cand.reason.trim() : '';
                      const candEvidenceUrl = cand && typeof cand.evidence_url === 'string' ? cand.evidence_url : '';
                      const isIngesting = cand && cand.status === 'ingesting';
                      const isInKdb = cand && cand.in_kdb === true;
                      const candKeymen = getCandidateKeymen(cand);
                      // 取り込み中でまだキーマンを取得できていない（ポーリング中）か
                      const isPollingPending = isIngesting && candKeymen.length === 0;
                      return (
                        <div
                          key={`wc-${message.id}-${i}`}
                          style={{ fontSize: '12px', padding: '4px 0', borderTop: i === 0 ? 'none' : '1px solid #eee' }}
                        >
                          <div style={{ fontWeight: 'bold' }}>
                            {candCompany}
                            {isPollingPending && (
                              <span style={{ marginLeft: 6, fontSize: '11px', color: '#b8860b' }}>
                                （取り込み中・キーマンを取得しています
                                <span className={classes.ingestingDots}><span>.</span><span>.</span><span>.</span></span>
                                ）
                              </span>
                            )}
                            {/* 収録済み or 取り込み完了(keymen取得後) は「KDB収録済み」に統一 */}
                            {!isPollingPending && (isInKdb || candKeymen.length > 0) && (
                              <span style={{ marginLeft: 6, fontSize: '11px', color: '#2e7d32' }}>（KDB収録済み）</span>
                            )}
                          </div>
                          {candReason !== '' && (
                            <div style={{ color: '#71737b', whiteSpace: 'pre-line' }}>{candReason}</div>
                          )}
                          {this.renderKeymenTable(`${message.id}#web`, candKeymen)}
                          {candEvidenceUrl !== '' && (
                            <a href={candEvidenceUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px' }}><span role="img" aria-label="根拠リンク">🔗</span>根拠</a>
                          )}
                        </div>
                      );
                    })}
                    {hasSelectableKeymen && this.renderSaveButton(`${message.id}#web`)}
                  </div>
                  );
                })()}
                {Array.isArray(message.roleGapCandidates) && message.roleGapCandidates.length > 0 && (() => {
                  // 役職欠損企業（企業はKDBにあるが該当役職の人だけWebで補完した候補）
                  // keymenは常に同梱される（ポーリング不要）。通常items[]と同一形式。
                  const roleGapKey = `${message.id}#roleGap`;
                  const anySelectable = message.roleGapCandidates.some(c => c && Array.isArray(c.keymen) && c.keymen.length > 0);
                  return (
                  <div style={{ marginTop: 8 }}>
                    <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: 4 }}>
                      該当役職をWebで補完した企業
                    </div>
                    {message.roleGapCandidates.map((cand, i) => {
                      const candCompany = cand && typeof cand.company === 'string' ? cand.company : '';
                      const candReason = cand && typeof cand.reason === 'string' ? cand.reason.trim() : '';
                      const candKeymen = cand && Array.isArray(cand.keymen) ? cand.keymen : [];
                      return (
                        <div
                          key={`rg-${message.id}-${i}`}
                          style={{ fontSize: '12px', padding: '4px 0', borderTop: i === 0 ? 'none' : '1px solid #eee' }}
                        >
                          <div style={{ fontWeight: 'bold' }}>{candCompany}</div>
                          {candReason !== '' && (
                            <div style={{ color: '#71737b', whiteSpace: 'pre-line' }}>{candReason}</div>
                          )}
                          {this.renderKeymenTable(roleGapKey, candKeymen)}
                        </div>
                      );
                    })}
                    {anySelectable && this.renderSaveButton(roleGapKey)}
                  </div>
                  );
                })()}
                {this.renderWebSectionStatus(message)}
              </div>
            );
          })}
          {isLoading && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '12px', marginBottom: '12px' }}>
              <div className={classes.chatLoadingMessage} style={{ marginLeft: 0, marginBottom: 0, lineHeight: 1, transform: 'translateY(-6px)' }}>
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>
              <span className={classes.shimmerText}>
                {this.state.includeWebDiscovery
                  ? 'Web検索で企業・役職を補完しています（数十秒かかることがあります）'
                  : 'AIが回答を考えています'}
              </span>
            </div>
          )}
          <div ref={this.setMessagesEndRef} />
        </div>
        </div>
        <div className={classes.chatInputContainer}>
          <div className={classes.centeredContent}>
          <label style={{ display: 'flex', alignItems: 'center', fontSize: '13px', color: '#71737b', marginBottom: 6, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={this.state.includeWebDiscovery}
              onChange={() => this.setState(prev => ({ includeWebDiscovery: !prev.includeWebDiscovery }))}
              style={{ marginRight: 6 }}
            />
Web検索で新規企業・役職も補完する（Keyman DBにない企業や役職を探します／応答が数十秒かかる場合があります）
          </label>
          <TextField
            fullWidth
            placeholder="探したいキーマンの条件・商材や、このアカウントの稼働状況について入力してください"
            className={classes.chatInputField}
            InputProps={{
              disableUnderline: true,
            }}
            multiline={true}
            rows={1}
            inputRef={(el) => { this.inputEl = el; this.adjustInputHeight(el); }}
            onInput={(e) => { this.adjustInputHeight(e.target); }}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                if (!this.inputEl) return;
                const val = this.inputEl.value;
                if (val && val.trim() !== '') {
                  if (typeof onSubmit === 'function') onSubmit(val.trim(), this.state.includeWebDiscovery);
                  this.inputEl.value = '';
                  this.adjustInputHeight(this.inputEl);
                }
              }
            }}
          />
          <div style={{ textAlign: 'center', fontSize: '12px', color: '#9aa0a6', marginTop: 8 }}>
            チャットはモデルのトレーニングには使用されません。Keyman Database AI は間違えることがあります。
          </div>
          </div>
        </div>
        </div>
        </div>
        <EditTagsDialog
          isOpen={this.state.editDialogOpen}
          toggleDialog={this.closeEditTagsDialog}
          hideDeleteSection={true}
          saveTags={this.saveTagsAiRecommend}
          getTags={this.props.getTags}
          options={this.props.options}
          isUpdatingTags={this.props.isUpdatingTags}
          isDeletingAddressTags={this.props.isDeletingAddressTags}
          errorMessage={this.props.errorMessage}
          selectCount={(this.state.editDialogSelectedIds || []).length}
          toggleCreateListDialog={this.props.toggleCreateListDialog}
          query={{ relocation_personnel_ids: this.state.editDialogSelectedIds || [] }}
          fromRecommend={true}
        />
        {this.renderNotification()}
      </Drawer>
    );
  }
}

ChatDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  // Tag dialog / recommend flow props (optional)
  getTags: PropTypes.func,
  options: PropTypes.array,
  isUpdatingTags: PropTypes.bool,
  isDeletingAddressTags: PropTypes.bool,
  errorMessage: PropTypes.string,
  toggleCreateListDialog: PropTypes.func,
  postExecutiveListUpdateTag: PropTypes.func,
  getWebCandidateKeymen: PropTypes.func,
  conversations: PropTypes.array,
  currentConversationId: PropTypes.string,
  onNewChat: PropTypes.func,
  onSelectConversation: PropTypes.func,
  onDeleteConversation: PropTypes.func,
  onSeeAllConditions: PropTypes.func,
};

export default withStyles(styles)(ChatDrawer);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/ChatDrawer.jsx